import React, { Component } from "react";
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';

const style = {
  height: '12rem',
  width: '12rem',
  marginRight: '1.5rem', 
  marginBottom: '1.5rem',
  color: 'white',
  padding: '1rem',
  textAlign: 'center',
  fontSize: '1rem',
  lineHeight: 'normal',
  float: 'left', 
}

const dropZoneStyle = {
  position: 'relative',
  zIndex: 1,
  background: '#FFFFFF',
  transition: '0.4s ease-in-out',
  width: '95%',
  borderRadius: 4,
  marginLeft: '2.5%',
  minHeight: 50,
  lineHeight: '50px',
  border: '1px dotted #8f8f8f',
  borderWidth: 2,
  textAlign: 'center',
  fontWeight: 'bold'
}

class DropZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: props.targetKey,
      idx: props.idx,
      fromInputKey: props.fromInputKey,
      toInputKey: props.toInputKey,
      onDropZone: false,

      exceptionItem: props.exceptionItem ? props.exceptionItem : '',

      newBackground: '#FFFFFF',
      textColor: '#919191'
    }
  } 

  dropped = (data) => {
    if( this.state.idx !== "" ){ data['idx'] = this.state.idx; }
    if( this.state.exceptionItem !== "" ){ data['item'] = this.state.exceptionItem; }
    data['fromInputKey'] = this.state.fromInputKey;
    data['toInputKey'] = this.state.toInputKey;
    this.props.dropToDayData(data);   
    this.setState({ onDropZone: false, newBackground: '#FFFFFF', textColor: '#919191' })
  }
  

  render() { 
    return (
      <DropTarget onHit={this.dropped} dropData={ this.dropped } onDragEnter={ () => { this.setState({ onDropZone: true, newBackground: '#4ff6c0db', textColor: '#000000' }) } } onDragLeave={ () => { this.setState({ onDropZone: false, newBackground: '#FFFFFF', textColor: '#919191' }) } } targetKey="timingOnly">
        <div style={{ ...dropZoneStyle, background: this.state.newBackground, color: this.state.textColor }}>{ this.state.onDropZone === true ? 'Drop it' : `Drop a popular hour for ${this.state.day}` }</div>
      </DropTarget>
    ) 

  }
}


export default DropZone;